/**
 * Theme Name: project-sscms v1.507.0
 * Theme URI: git+https://github.com/1debit/project-sscms.git
 * Author: Sharp Notions, LLC
 * Author URI: https://sharpnotions.com
 * Description: Wordpress theme for Chime (project-sscms) [main - 9a4e5a170]
 * Version: 1.507.0-2025-07-10T15-30-54
 * License: ISC
 * License URI: "http://www.gnu.org/licenses/gpl-2.0.html"
 */
/**
 * File animate.js.
 * Handles animation-related functionality
 */

const fadeUps = document.querySelectorAll('.animate--fadeup');
const parallaxes = document.querySelectorAll('.animate--parallax');
const moveLefts = document.querySelectorAll('.animate--moveleft');
const slideLefts = document.querySelectorAll('.animate--slideleft');

let fadeUpCb = (entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) { 
      entry.target.classList.add('animate--fadeup-animate');
      observer.unobserve(entry.target);
    }
  });
}

let parallaxCb = (entries, observer) => {
  entries.forEach(entry => {
    let moveAmount = entry.target.getAttribute('data-parallax-move'); // px to move
    let cssProp = entry.target.getAttribute('data-parallax-prop') || 'backgroundPosition';
    let buffer = entry.target.getAttribute('data-parallax-buffer') || 0;
    let moveEl = (cssProp == 'objectPosition')
      ? entry.target.querySelector('img')
      : entry.target;

    moveAmount = moveAmount / 100;
    window.addEventListener("scroll", () => {
      if (entry.isIntersecting) {
        let pos = buffer - (1 + moveAmount * percentageSeen(entry.target));
        moveEl.style[cssProp] = `center ${pos}px`;
      }
    });
  });
}

let moveLeftCb = (entries, observer) => {
  entries.forEach(entry => {
    let moveAmountDesktop = entry.target.getAttribute('data-parallax-move-desktop'); // percent to move on desktop
    let moveAmountMobile = entry.target.getAttribute('data-parallax-move-mobile'); // percent to move on mobile
    let moveAmount = typeof isMobile == 'function' && isMobile() ? moveAmountMobile : moveAmountDesktop;
    moveAmount = moveAmount / 100;
    window.addEventListener("scroll", () => {
      if (entry.isIntersecting) {
        let translateVal = `-${1 + moveAmount * percentageSeen(entry.target)}%`;
        let transform = `transform:translateX(` + translateVal + `);-webkit-transform:translateX(` + translateVal + `);`;
        entry.target.setAttribute('style', transform);
      }
    });
  });
}

let slideLeftCb = (entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) { 
      entry.target.classList.add('animate--slideleft-animate');
      observer.unobserve(entry.target);
    }
  });
}

let fadeUpObserver = new IntersectionObserver(fadeUpCb, {
  threshold: 0.7
});

let parallaxObserver = new IntersectionObserver(parallaxCb, {
  rootMargin: '0px 0px 10px 0px'
});

let moveLeftObserver = new IntersectionObserver(moveLeftCb, {
  threshold: 0
});

let slideLeftObserver = new IntersectionObserver(slideLeftCb, {
  threshold: 0.25
});

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elPosY = element.getBoundingClientRect().top + scrollY;
  const elHeight = element.offsetHeight;

  if (elPosY > scrollY + viewportHeight) {
    return 0;
  } else if (elPosY + elHeight < scrollY) {
    return 100;
  } else {
    const distance = scrollY + viewportHeight - elPosY;
    const percentage = Math.round(distance / ((viewportHeight + elHeight) / 100));
    return percentage;
  }
}

// Init
if (fadeUps.length) {
  fadeUps.forEach(fadeUp => {
    fadeUpObserver.observe(fadeUp);
  });  
}
if (parallaxes.length) {
  parallaxes.forEach(parallax => {
    parallaxObserver.observe(parallax);
  });  
}
if (moveLefts.length) {
  moveLefts.forEach(moveLeft => {
    moveLeftObserver.observe(moveLeft);
  });  
}
if (slideLefts.length) {
  slideLefts.forEach(slideLeft => {
    slideLeftObserver.observe(slideLeft);
  });  
}
